export * from './group-tech-class.dto'
export * from './group-tech-class-response'
export *from './all-group-tech-class-response'
export * from './group-tech-class.request'